import React from "react";
import clsx from "clsx";
import { useCarConfigSelector } from "../../../../../redux/store";
import type { ExtraType, UpholsteryType } from "../../../../../../../../common-deprecated/types/CommonTypes";
import type { UpholsteryFromOtherGradesType } from "../../../../../../../shared-logic/types/AvailableInOtherGradesType";
import { getCarDBAssetUrl } from "../../../../../../../shared-logic/utils/imageUtils";
import { showAccessoriesRate } from "../../../../../utils/financeInsuranceRate";
import { CarConfigLabel } from "../../../../../utils/labelUtils";
import Price from "../../../common/price/Price";
import Button from "../../../../../../shared-components/css-modules/lexus/atoms/Button";
import Text from "../../../../../../shared-components/css-modules/lexus/atoms/Text";
import Icon from "../../../../../../shared-components/css-modules/lexus/atoms/Icon";
import cardStyles from "../../../../../../shared-components/css-modules/lexus/molecules/Card.module.scss";
import styles from "./UpholsteryCard.module.scss";

export type UpholsteryCardType = {
    upholstery: UpholsteryType | ExtraType | UpholsteryFromOtherGradesType;
    active?: boolean;
    style?: React.CSSProperties;
    onClick?: () => void;
};

const UpholsteryCard = (props: UpholsteryCardType): JSX.Element | null => {
    const { upholstery, active, style, onClick } = props;
    const commonSettings = useCarConfigSelector((state) => state.commonSettings);
    const carConfigSettings = useCarConfigSelector((state) => state.carConfigSettings);

    return (
        <div className={clsx(styles.upholsteryCard, active ? cardStyles.active : cardStyles.clickable)} style={style}>
            <img
                src={getCarDBAssetUrl(
                    upholstery.image,
                    commonSettings.compressedCcisPath,
                    225,
                    225,
                    true,
                    commonSettings,
                )}
                loading="lazy"
                data-decorative="yes"
                alt=""
            />
            <div className={styles.body}>
                <Text tag="h2" variant="apheleia-h4" className={styles.title}>
                    {upholstery.name}
                </Text>
                {"description" in upholstery && upholstery.description && (
                    <Text
                        tag="span"
                        variant="apheleia-body"
                        className={styles.description}
                        dangerouslySetInnerHTML={{
                            __html: upholstery.description,
                        }}
                    />
                )}
                <div className={styles.footer}>
                    {active ? (
                        <>
                            <span className={styles.included}>
                                <CarConfigLabel label="carConfigIncluded" />
                            </span>
                            <Button
                                variant="swatch"
                                aria-label={upholstery.name}
                                aria-pressed={active}
                                className={styles.button}
                                disabled
                            >
                                <Icon variant="check" sizing="sm" aria-hidden="true" />
                            </Button>
                        </>
                    ) : (
                        <>
                            {"price" in upholstery && upholstery.price && (
                                <Price
                                    price={upholstery.price}
                                    forceCashPrice={!showAccessoriesRate(commonSettings, carConfigSettings)}
                                />
                            )}
                            <Button
                                key={upholstery.id}
                                variant="swatch"
                                aria-label={upholstery.name}
                                className={styles.button}
                                onClick={onClick}
                            >
                                <Icon variant="plus" sizing="sm" aria-hidden="true" />
                            </Button>
                        </>
                    )}
                </div>
            </div>
        </div>
    );
};

export default UpholsteryCard;
